import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { chevronDownIcon } from '../../../icons';
import { FacetStateService } from '../../core/facet-state.service';
import { ExpansionPanelComponent } from '../../expansion-panel/expansion-panel.component';
import { FilterService } from '../../filter-service/filter.service';
import { ISelectOptions } from '../../form-elements/select/select.component';
import { COLLAPSE_PANELS } from '../../models/filter.models';
import { FilterPageService } from '../../pages/filter-page/filter-page.service';

@Component({
    selector: 'app-filter-sorting',
    template: `
        <div class="facet filter-sorting">
            <app-expansion-panel #panel [headerClickable]="true" [expanded]="expandPanel" (changed)="onPanelChange($event)">
                <h6 class="facet__title" expansion-title [class.facet__title--no-margin]="!panel.animating && !panel.expanded">
                    {{ 'filterpage.sorting____choose' | translate }}
                </h6>
                <ng-container expansion-icon>${chevronDownIcon}</ng-container>
                <ul class="facet__list" *ngIf="sortingOptions$ | async as options">
                    <li *ngFor="let radio of options">
                        <!-- <app-fade-in> -->
                            <label class="radio animate-fade-in">
                                <input
                                    type="radio"
                                    [value]="radio.value"
                                    [checked]="radio.value == (filterService.activeSorting | async)"
                                    (click)="handleChange(radio)"
                                />
                                <span class="radio__dot"></span>
                                {{ radio.displayName }}
                            </label>
                        <!-- </app-fade-in> -->
                    </li>
                </ul>
            </app-expansion-panel>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSortingComponent implements OnInit {
    @ViewChild('panel') panel: ExpansionPanelComponent;

    sortingOptions$: Observable<ISelectOptions[]>;
    sortingLabel = 'sorting';
    expandPanel = false;

    constructor(
        public readonly filterService: FilterService,
        public readonly filterPageService: FilterPageService,
        private readonly facetStateService: FacetStateService,
        @Optional() @Inject(COLLAPSE_PANELS) private collapsePanels: boolean
    ) {}

    ngOnInit(): void {
        this.sortingOptions$ = this.filterPageService.sortingOptions$;
        const expandState = this.facetStateService.getExpandedState(this.sortingLabel);
        this.expandPanel = expandState ?? this.collapsePanels ?? true;
    }
    handleChange(option: ISelectOptions) {
        this.filterService.setSorting(`${option.value}`);
    }

    onPanelChange(value: boolean) {
        if (value) {
            this.facetStateService.storeFacetAsExpanded(this.sortingLabel);
        } else {
            this.facetStateService.storeFacetAsColapsed(this.sortingLabel);
        }
    }
}
